import { Box, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { InputItem } from './InputField.styled';
import Chip from '@material-ui/core/Chip';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const InputField = ({
    inputRef,
    placeholder,
    params,
    isDefault = false,
    isShipTo = false,
    paddingTop,
    height,
    isBorderColor,
    borderRadius,
    padding,
    background,
}) => {
    const [inputValue, setInputValue] = useState(
        params?.inputProps?.value || ''
    );
    const [inputStyle, setInputStyle] = useState({});

    useEffectWithErrorLogging(() => {
        if (isDefault && params?.inputProps?.value !== undefined) {
            setInputValue(params.inputProps.value);
            const averageCharWidth = 16;
            const padding = 10;
            const calculatedWidth =
                (params?.inputProps?.value.length + 1) * averageCharWidth +
                padding;
            setInputStyle((prevStyle) => ({
                ...prevStyle,
                width: `${calculatedWidth}px`,
            }));
        } else if (!isDefault && params?.inputProps?.value !== undefined) {
            setInputStyle((prevStyle) => ({
                ...prevStyle,
                width: '100%',
            }));
        }
    }, [params]);
    return (
        <InputItem
            isDefault={isDefault}
            isShipTo={isShipTo}
            paddingTop={paddingTop}
            height={height}
            isBorderColor={isBorderColor}
            borderRadius={borderRadius}
            padding={padding}
            background={background}
        >
            <React.Fragment>
                <Box className="inputSearch" ref={params?.InputProps.ref}>
                    <TextField 
                        inputRef={inputRef}
                        placeholder={placeholder}
                        className="searchtStyle"
                        InputProps={{
                            ...params.InputProps,
                            style: inputStyle,
                            endAdornment: (
                                <>
                                    {isDefault && (
                                        <Chip
                                            className="chipName"
                                            label={'Default'}
                                        />
                                    )}
                                    {params.InputProps?.endAdornment}
                                </>
                            ),
                        }}
                        {...params?.inputProps}
                    />
                    {/* <InputItem /> */}
                </Box>
            </React.Fragment>
        </InputItem>
    );
};

export default InputField;
